import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const EmailErrorTableRow = ({
  id,
  onClick,
  providerName,
  customerName,
  type,
  customerClass,
  status,
  destEmail,
  body,
}) => (
  <TableRow key={id} id={id} onClick={onClick} hover>
    <TableCell>{providerName}</TableCell>
    <TableCell>{customerName}</TableCell>
    <TableCell>{type}</TableCell>
    <TableCell>{customerClass}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell>{destEmail}</TableCell>
    <TableCell>{body}</TableCell>
  </TableRow>
);

export default EmailErrorTableRow;
